// extracted by mini-css-extract-plugin
module.exports = {"badgeImage":"ProfileCardImageBadge_badgeImage__AOjBE"};